// @flow
import { getCampaign } from './basicCreators';
import { APIError } from '../generalCreators';

export function updateCurrentCampaign(
  campaignId: number,
  organisationId: number
): any {
  return function(dispatch) {
    if (campaignId) {
      // Get the campaign details
      return dispatch(getCampaign(campaignId, organisationId)).then(
        response =>
          dispatch({ type: 'UPDATE_CURRENT_CAMPAIGN', campaign: response }),
        error => dispatch(APIError(error, 'Error updating current Campaign'))
      );
    } else {
      const result = dispatch({ type: 'CLEAR_CURRENT_CAMPAIGN' });
      return Promise.resolve(result);
    }
  };
}

export function updateCurrentCampaignStep(statusTypeId: number): any {
  return function(dispatch) {
    return dispatch({ type: 'UPDATE_CURRENT_CAMPAIGN_STEP', statusTypeId });
  };
}



// WEBPACK FOOTER //
// ./src/actions/campaigns/currentCampaignCreators.js